import React, { useState } from "react";

const TextArea = ({
    type = "text",
    placeholder,
    inputProps,
    label = "label",
}) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
        <div
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            className="w-full relative"
        >
            {/* {isFocused && (
        <span
          className="text-sm text-white bg-tblu px-4 rounded-full absolute left-2 top-0"
          style={{ transform: "translateY(-50%)" }}
        >
          {label}
        </span>
      )} */}
            <h2 className="text-tblu">{label}</h2>
            <textarea
                className="w-full my-2 block p-4 border-slate-200 border rounded-xl focus:outline-tblu"
                type={type}
                placeholder={placeholder}
                {...inputProps}
            />
        </div>
    );
};

export default TextArea;
